import React, { Component } from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { connect } from 'react-redux';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { selectDeviceType } from 'yoda-site-components/lib/selectors/ContextSelector';
import {
    KEY_FEATURE_CONSTS_MIN_ICONS_COUNT,
    KEY_FEATURE_CONSTS_MAX_ICONS_COUNT,
} from 'yoda-site-components/lib/common/Constants';
import styles from './KeyFeatures.css';
import SectionTitle from '../PDPSectionTitle/PDPSectionTitle';

const cx = classnames.bind(styles);

class KeyFeatures extends Component {
    static propTypes = {
        deviceType: PropTypes.object,
        // triggerAnalytics: PropTypes.func,
        featureAttributes: PropTypes.arrayOf(PropTypes.object),
    };

    static defaultProps = {
        deviceType: {},
        triggerAnalytics: noop,
        featureAttributes: [],
        actions: {},
    };

    constructor(props) {
        super(props);

        const { deviceType, featureAttributes } = props;

        this.resultFeatures = featureAttributes;
        this.atId = 'at-key-features';
        this.titleStyles = {
            marginTop: deviceType.isMobile ? '5px' : '',
        };
    }

    /* istanbul ignore next */
    componentDidUpdate() {
        const { featureAttributes } = this.props;

        const moreThanMaxFeatures = featureAttributes.length >= KEY_FEATURE_CONSTS_MAX_ICONS_COUNT;

        this.resultFeatures = moreThanMaxFeatures
            ? featureAttributes.slice(0, KEY_FEATURE_CONSTS_MAX_ICONS_COUNT)
            : featureAttributes;
    }

    showFeaturesSection = (resultFeatures) => {
        const { deviceType } = this.props;
        const { isMobile, isTablet } = deviceType;
        if (resultFeatures.length >= KEY_FEATURE_CONSTS_MIN_ICONS_COUNT) {
            return (
                <div
                    data-automation-id={this.atId}
                    className={cx('wrapper', { wrapperDesktop: !isMobile })}
                >
                    <div
                        className={`${cx('md12', 'lg12', 'xl12', {
                            featuresTitleMobile: isMobile,
                        })} ${dt(['mb-4'])}`}
                    >
                        <div>
                            <SectionTitle
                                className={dt([
                                    'text-xLg',
                                    'font-open-sans-semibold',
                                    'leading[1.6]',
                                    'text-center',
                                ])}
                            >
                                Features
                            </SectionTitle>
                        </div>
                    </div>
                    <div className={cx('md12', 'lg12', 'xl12', 'featuresBody')}>
                        <ul
                            className={`${cx('featureAttrs-list', {
                                listNonDesktop:
                                    (isMobile && resultFeatures.length > 2) ||
                                    (isTablet && resultFeatures.length > 7),
                            })} ${dt(['flex', 'justify-center', 'm-0', 'h-full'])}`}
                        >
                            {resultFeatures.length && resultFeatures.map(this.featureItemRenderer)}
                        </ul>
                    </div>
                </div>
            );
        }

        return null;
    };

    featureItemRenderer = (item) => {
        const itemId = `${this.atId}-${item.value.toLowerCase().replace(' ', '-')}`;
        const keyId = `${item.value}${Math.random()}`;
        return (
            <li key={keyId} className={cx('item', 'keyFeatureSpacer')} data-automation-id={itemId}>
                <div className={cx('icon-wrapper')}>
                    <img
                        className={`${cx('item-icon')} ${dt(['w-12', 'h-[34px]'])}`}
                        data-automation-id={`${itemId}-icon`}
                        src={item.icon}
                        alt=""
                    />
                </div>
                <div className={cx('item-text')}>{item.value}</div>
            </li>
        );
    };

    render() {
        return (
            <div>
                {this.resultFeatures.length >= KEY_FEATURE_CONSTS_MIN_ICONS_COUNT &&
                    this.showFeaturesSection(this.resultFeatures)}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    deviceType: selectDeviceType(state),
});

export default connect(mapStateToProps, null)(KeyFeatures);
